module.exports = __webpack_public_path__ + "img/yillionbank.9decf53d.png";